import { get } from "lodash";
import curryConnector from "utils/connectors";

export const USER_IMPORT_LOG_DETAILS_STATE_KEY = "userImportLogDetails";

export const ActionTypes = {
  LOADING_USER_IMPORT_LOG_DETAILS: "LOADING_USER_IMPORT_LOG_DETAILS",
  ERROR_LOADING_USER_IMPORT_LOG_DETAILS: "ERROR_LOADING_USER_IMPORT_LOG_DETAILS",
  LOADED_USER_IMPORT_LOG_DETAILS: "LOADED_USER_IMPORT_LOG_DETAILS",
};

const initialState = {
  userImportLogDetails: null,
  loading: false,
  error: null,
  loaded: false,
};

const curry = fn => curryConnector(fn, USER_IMPORT_LOG_DETAILS_STATE_KEY);

export default ((state, action) => {
  switch (action.type) {
    case ActionTypes.LOADING_USER_IMPORT_LOG_DETAILS:
      return { ...state, loading: true, loaded: false, error: null };

    case ActionTypes.ERROR_LOADING_USER_IMPORT_LOG_DETAILS:
      return { ...state, loading: false, loaded: false, error: action.payload.message };

    case ActionTypes.LOADED_USER_IMPORT_LOG_DETAILS:
      return {
        ...state,
        loading: false,
        error: null,
        loaded: true,
        userImportLogDetails: action.payload.userImportLogDetails,
      };

    default:
      return state || initialState;
  }
});

export const isUserImportLogDetailsLoading = curry(({ localState }) => get(localState, ["loading"], false) === true);

export const isUserImportLogDetailsLoadingError = curry(({ localState }) => get(localState, ["error"], null));

export const isUserImportLogDetailsLoaded = curry(({ localState }) => get(localState, ["loaded"], false) === true);

export const getUserImportLogDetails = curry(({ localState }) => get(localState, ["userImportLogDetails"], null));

export const getErrorMessage = curry(({ localState }) => {
  const error = get(localState, ["error"], null);
  if (!error) return null;
  return error;
});
